/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import {
  firebaseConnect,
  isLoaded,
  isEmpty
} from 'react-redux-firebase'
import {  Container, Table, Header, Popup, Rating, Icon, Loader, List  } from 'semantic-ui-react'

import { isAdmin } from './helpers';
// import { Text } from 'react-native';

class Users extends Component {

  state = {
    column: 'date',
    data: [],
    direction: 'descending',
    loading: true,
  }

  componentDidUpdate(prevProps, prevState) {
    const { users } = this.props
    // set user data from firebase
    if(isLoaded(users) && this.state.data.length === 0 && this.state.loading) {
      // Initialize Data after filtering out entries without a username
      let filteredUsers = _.map(users, (u, key) => { return {...u, userId: key} } ); // retain key
      this.initialSort(_.pickBy(filteredUsers, u => u.username) );


      // this._doSomeShitForEveryUser(); // TMP!!!!
    }
  }

  _doSomeShitForEveryUser = () => {
    // // TMP!!!! DO THIS ONCE
    // _.forEach(users, (user, key) => {
    //   // add a value to every user
    //   this.props.firebase.update(`users/${key}`, { "1_1_updatedUsername": true });
    // });
  }

  // Initial Sort by date
  initialSort = (data) => {
    // console.log(data)
    const { column } = this.state
      this.setState({
        data: _.sortBy(data, [column]).reverse(),
        loading: false,
      });
  }

  handleSort = clickedColumn => () => {
    const { column, data, direction } = this.state

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        data: _.sortBy(data, [clickedColumn]),
        direction: 'ascending',
      })

      return
    }

    this.setState({
      data: data.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  render() {

    const { column, data, direction, loading  } = this.state

    if(!isAdmin(this.props.auth))
      return null

    if(loading) { return <Loader active /> }

    return (
      <Container>

        <Header as='h2'>Users ({data.length})</Header>

        <Table sortable celled >
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                width={3}
                sorted={column === 'username' ? direction : null}
                onClick={this.handleSort('username')}
              >
                Username
              </Table.HeaderCell>
              <Table.HeaderCell
              width={3}
                sorted={column === 'date' ? direction : null}
                onClick={this.handleSort('date')}
              >
                Date
              </Table.HeaderCell>
              <Table.HeaderCell
              width={1}
                sorted={column === 'token' ? direction : null}
                onClick={this.handleSort('token')}
              >
                Token
              </Table.HeaderCell>
              <Table.HeaderCell
              width={3}
                sorted={column === 'messages' ? direction : null}
                onClick={this.handleSort('messages')}
              >
                Messages
              </Table.HeaderCell>
              <Table.HeaderCell
              width={9}
                sorted={column === 'messages' ? direction : null}
                onClick={this.handleSort('messages')}
              >
                Subscriptions
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {_.map(data, (user, key) => (
              <Table.Row key={Math.random()}>
                <Table.Cell><Header as='h5' textAlign='left'>
                <Popup trigger={<p>{user.username || ''}</p>} content={user.userId} />
                </Header></Table.Cell>
                <Table.Cell>{user.date}</Table.Cell>
                <Table.Cell>{user.token && <Rating icon='star' defaultRating={1} maxRating={1} /> }</Table.Cell>
                <Table.Cell>
                {
                  _.map(user.messages, (received, key) =>
                    <Icon key={key} name='mail' size='small' color={received ? 'green' : 'red'} />)
                }
                </Table.Cell>
                <Table.Cell>
                  <List size='mini'>
                  {
                    _.map(user.subscriptions, (subscription, key) =>
                      <List.Item icon={subscription ? 'bell' : 'bell slash'} key={key} content={key} /> )
                  }
                  </List>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>

      </Container>
    )
  }
}

export default compose(
  firebaseConnect([
    'users'
  ]),
  connect((state) => ({
    users: state.firebase.data.users,
    auth: state.firebase.auth,
  }))
)(Users)



// WEBPACK FOOTER //
// ./src/components/pages/admin/UsersList.js